import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUserEPto } from "../../../api/EmergencyPTO/getAllEPtobyUser";
import { useAuthContext } from "../../../hooks";
import EPtoSc from "./index.sc";
import Modal from "../ApprovalModal/index";
import { getReportsToEmail } from "../../../api/EmergencyPTO/get_reports_to_email";

function Index() {
  const [ePto, setEPto] = useState([]);
  const auth = useAuthContext();
  const params = useParams();
  const navigate = useNavigate();

  const fetchUserEPto = async () => {
    try {
      const data = await getUserEPto(
        auth?.userInfo?.orgs[0]?.id,
        params?.employeeId
      );
      setEPto(data);
    } catch (error) {
      console.log(error);
    }
  };

  const [repEmail, setRepEmail] = useState<any>([]);
  const getReportsToEmailFun = async () => {
    setRepEmail(
      await getReportsToEmail(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
    console.log("leave history details");
  };

  useEffect(() => {
    fetchUserEPto();
    getReportsToEmailFun();
  }, []);
  console.log(repEmail?.[0]?.reports_to_id?.length > 0, "rep email");
  return (
    <EPtoSc>
      <table>
        <thead>
          <tr>
            <th className="heading">Leave Type</th>
            <th className="heading">Start date</th>
            <th className="heading">End date</th>
            <th className="heading">Duration</th>
            <th className="heading">Reporting Manager</th>
            <th className="heading">Country Manager</th>
            <th className="heading"></th>
          </tr>
        </thead>

        <tbody>
          {ePto?.map((data: any) => {
            return (
              <tr key={data.id}>
                <td>
                  {data?.leave_type_id === 2 ? "Emergency PTO" : "Comp Off"}
                </td>
                <td>{data?.start_date}</td>
                <td>{data?.end_date}</td>
                <td>
                  {data?.duration < 1 ? (
                    <>{data?.duration} hours</>
                  ) : data?.duration === 1 ? (
                    <>1 day</>
                  ) : (
                    <>{data?.duration} days</>
                  )}
                </td>
                {data?.status === "approve" || data?.status === "decline" ? (
                  <td>{data?.status}d</td>
                ) : (
                  <td>No response</td>
                )}
                 {data?.e_pto_approved_c_manager === 1  ? (
                  <td>Approved</td>
                ) : (
                  data?.e_pto_approved_c_manager === 0  ?(<td>Declined</td>):(<td>No response</td>)
                )}
                <td>
                  <Modal data={data} fetchUser={fetchUserEPto} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </EPtoSc>
  );
}

export default Index;
